const OnSelect = function(ids) {
  this.collection.selected_rows = ids
  this.collection.setSelectedUser(ids)
}
export default OnSelect